import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

interface FeatureListProps {
  features: string[]
  columns?: boolean
}

export function FeatureList({ features, columns = false }: FeatureListProps) {
  return (
    <ul
      className={cn(
        'flex-1 space-y-3 mb-4',
        columns && 'md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-3 md:space-y-0'
      )}
    >
      {features.map((feature) => (
        <li key={feature} className="flex items-start gap-3 text-sm text-[#999]">
          <Check className="size-4 text-[#666] shrink-0 mt-0.5" />
          <span>{feature}</span>
        </li>
      ))}
    </ul>
  )
}
